
import React from "react";
import { cleanHashtags } from "../utils/objectionsParser";
import SectionHeader from "./SectionHeader";
import { Separator } from "@/components/ui/separator";

interface TextSectionProps {
  number: string | number;
  title: string;
  content: string;
  isLast?: boolean;
}

const TextSection: React.FC<TextSectionProps> = ({ 
  number, 
  title, 
  content,
  isLast = false 
}) => {
  return (
    <>
      <div>
        <SectionHeader number={number} title={title} />
        <div className="prose prose-lg max-w-none text-left">
          <p className="text-[#403E43] whitespace-pre-line text-left">
            {cleanHashtags(content)}
          </p>
        </div>
      </div>
      
      {!isLast && <Separator className="bg-heaven-gold/10" />}
    </>
  );
};

export default TextSection;
